export default __webpack_public_path__ + "static/media/on-site.e7b0e7c4.png";